<template>
  <v-card class="Type-service">
    <div class="pa-8">
      <h4 class="Type-service-title">
        {{ title }}
      </h4>
      <div class="line-legend" v-html="chartLegend"></div>

      <DoughnutChart
        :chart-data="datacollection"
        :text="$t('appointment.plural')"
        :value="totalText"
        :total="total"
        @sendLegend="setLegend"
      ></DoughnutChart>
    </div>
  </v-card>
</template>

<script>
import DoughnutChart from './DoughnutChart.js'

export default {
  components: {
    DoughnutChart
  },
  data() {
    return {
      datacollection: null,
      chartLegend: null
    }
  },
  props: {
    total: Number,
    totalText: String,
    title: String,
    dataDoughnut: {
      type: Array
    }
  },
  mounted() {
    this.fillData()
  },
  methods: {
    fillData() {
      let labels = []
      let values = []
      let colors = []

      let dynamicColors = function() {
        const r = Math.floor(Math.random() * 255)
        const g = Math.floor(Math.random() * 255)
        const b = Math.floor(Math.random() * 255)
        return 'rgb(' + r + ',' + g + ',' + b + ')'
      }

      for (const [key, value] of Object.entries(this.dataDoughnut)) {
        colors.push(value.color ? value.color : dynamicColors())
        labels.push(this.$t(`services.${key}`))
        values.push(value.count)
      }
      this.datacollection = {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors,
            hoverOffset: 4
          }
        ]
      }
    },
    setLegend(html) {
      this.chartLegend = html
    }
  }
}
</script>

<style scoped lang="scss">
.Type-service {
  width: 100%;
  height: 100%;
  color: var(--v-text-base);
}

.Type-service-title {
  font-size: 18px;
  font-weight: bold;
}
</style>
